import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=ee9e4a82&scoped=true&"
var script = {}
import style0 from "./trash.vue?vue&type=style&index=0&id=ee9e4a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9e4a82",
  null
  
)

export default component.exports